import React from "react";

// Twitter-style blue "verified" seal shown next to a contact once send-vetting
// has confirmed it's a real, deliverable human/company (sendVetStatus ===
// 'verified'). Renders nothing for pending/rejected so the UI stays clean.
// Pass the contact's sendVetStatus; optional size + title override.
export default function VerifiedTick({ status, size = 13, title, style }) {
  if (status !== "verified") return null;
  return (
    <span
      title={title || "Verified — real, deliverable contact (send-vetted)"}
      aria-label="verified"
      style={{ display: "inline-flex", verticalAlign: "middle", marginLeft: 4, color: "#1d9bf0", ...style }}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 1.6l2.6 2 3.25.22.98 3.13 2.37 2.15-1.19 3.05 1.19 3.05-2.37 2.15-.98 3.13-3.25.22-2.6 2-2.6-2-3.25-.22-.98-3.13-2.37-2.15 1.19-3.05L2.79 8.95l2.37-2.15.98-3.13L9.4 3.6l2.6-2z" />
        <path d="M10.5 14.7l-2.35-2.35-1.2 1.2 3.55 3.55 6-6-1.2-1.2z" fill="#fff" />
      </svg>
    </span>
  );
}
